import FilterForm from 'components/forms/FilterForm';
import { Col, Form, Input, Row, Select, Table } from 'antd';
import { CrudFilters, HttpError } from '@refinedev/core';
import { IOrderPaymentPlansSummary } from 'interfaces/orders';
import { InputMask } from 'components/form-items/InputMask';
import { ListLayout } from 'components/layout/layout/ListLayout';
import { ShowButton, TextField, useTable } from '@refinedev/antd';
import { formatMoney } from 'services/money';

interface IFilter {
  userName: string[];
  userEmail: string[];
  userDocumentInfo: string[];
  orderNumber: string[];
  productableType: string[];
}

export const OrderPaymentPlansList = () => {
  const { tableProps, searchFormProps } = useTable<
    IOrderPaymentPlansSummary,
    HttpError,
    IFilter
  >({
    onSearch: params => {
      const filters: CrudFilters = [];
      const {
        userName,
        userEmail,
        userDocumentInfo,
        orderNumber,
        productableType
      } = params;

      filters.push(
        {
          field: 'filter[order][order_number]',
          operator: 'eq',
          value: orderNumber
        },
        {
          field: 'filter[user][email]',
          operator: 'eq',
          value: userEmail
        },
        {
          field: 'filter[user][document_info]',
          operator: 'eq',
          value: userDocumentInfo
        },
        {
          field: 'filter[order][productable_type]',
          operator: 'eq',
          value: productableType
        },
        {
          field: 'filter[user][name]',
          operator: 'eq',
          value: userName
        }
      );

      return filters;
    },

    resource: `payment_plans`,

    pagination: {
      pageSize: 5
    }
  });

  return (
    <Row gutter={[16, 16]}>
      <Col span={24}>
        <ListLayout title="Buscas">
          <FilterForm searchFormProps={searchFormProps}>
            <Form.Item name="orderNumber">
              <Input placeholder="Número do pedido" />
            </Form.Item>

            <Form.Item name="userEmail">
              <Input placeholder="E-mail do aluno" />
            </Form.Item>

            <Form.Item name="userDocumentInfo">
              <InputMask placeholder="CPF do aluno" mask="000.000.000-00" />
            </Form.Item>

            <Form.Item name="userName">
              <Input placeholder="Nome do aluno" className="lg:min-w-[300px]" />
            </Form.Item>

            <Form.Item name="productableType">
              <Select placeholder="Produto" className="lg:!min-w-[300px]">
                <Select.Option key="::Graduate::Course">
                  Curso regulado
                </Select.Option>
                <Select.Option key="::Course">Curso avulso</Select.Option>
              </Select>
            </Form.Item>
          </FilterForm>

          <Table {...tableProps} rowKey="id">
            <Table.Column
              dataIndex={['user', 'name']}
              key="user_name"
              title="Nome do aluno"
              render={value => <TextField value={value} />}
            />
            <Table.Column
              dataIndex={['user', 'document_info']}
              key="document_info"
              title="CPF"
              render={value => <TextField value={value || '-'} />}
            />
            <Table.Column
              dataIndex={['user', 'email']}
              key="email"
              title="Email"
              render={value => <TextField value={value} />}
            />
            <Table.Column
              dataIndex={['user', 'phone_number']}
              key="phone_number"
              title="Telefone"
              render={value => <TextField value={value || '-'} />}
            />
            <Table.Column
              dataIndex={['order', 'number']}
              key="order_number"
              title="Número do pedido"
              render={value => <TextField value={value} />}
            />
            <Table.Column
              dataIndex={['order', 'debit_amount']}
              key="debit_amout"
              title="Inadimplência"
              render={value => <TextField value={formatMoney(value)} />}
            />
            <Table.Column<IOrderPaymentPlansSummary>
              title="Ações"
              dataIndex="actions"
              align="center"
              width={80}
              render={(_, record) => {
                return (
                  <ShowButton
                    hideText
                    size="small"
                    recordItemId={record.order.id}
                  />
                );
              }}
            />
          </Table>
        </ListLayout>
      </Col>
    </Row>
  );
};
